import styled from 'styled-components';

import { COLORS } from '@theme/colors';
import { media } from '@theme/media';
import { OFFSET } from '@theme/helpers';

export const Container = styled.a`
  border: 1px solid ${COLORS.BLACK};
  padding: ${OFFSET.M};
  margin-bottom: ${OFFSET.XS};
  max-width: 306px;
  display: block;
  width: calc(100vw - ${OFFSET.XL});

  &:nth-child(2n + 1) {
    margin-right: 30px;
  }

  ${media.tablet} {
    width: calc(50% - 15px);
  }

  &:hover {
    background-color: ${COLORS.BLACK};
    color: ${COLORS.WHITE};
  }
`;

export const GalleryName = styled.div`
  text-transform: uppercase;
`;

export const GalleryRow = styled.div`
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
`;
